export default {
  commen: {
    pageTitle:
      "义乌|深圳到墨西哥美客多专线_亚马逊专线_双清包税-浙江喜航供应链有限公司",
    companyName: "浙江喜航供应链有限公司",
    phone: "电话",
    address: "地址",
    email: "邮箱",
    slogan: "深耕墨西哥市场",
    slogan1: "提供全方位的物流解决方案",
    introduce:
      "浙江喜航供应链有限公司，自2021年成立以来，始终致力于为跨境电商提供卓越的物流解决方案。公司总部坐落于浙江义乌，拥有超过2000平方米的现代化办公与操作空间，并在墨西哥设有占地16000平方米的先进仓储设施。我们拥有一支200多人的专业团队，是亚马逊和美客多等知名电商平台的官方物流服务商，专注于墨西哥市场的跨境电商物流服务。",
    introduce9:
      "喜航供应链在全国范围内设有2家子公司，提供从货物揽收、操作、订舱、拖车、清关、提柜到海外仓储及末端派送的一站式物流服务。我们致力于帮助客户实现销售目标，助力其业务增长。",
    introduce10:
      "我们的服务网络覆盖墨西哥主要城市，包括墨西哥城、蒙特雷市和瓜达拉哈拉市。主营业务涵盖亚马逊、美客多和虾皮的送仓服务，墨西哥海外仓仓储及全境无盲点的小包派送服务，以及电商辅助提货、换标、再送仓等增值服务。此外，我们还提供整柜和拼箱的清关派送服务，满足不同客户的需求。",
    introduce11:
      "随着墨西哥电商市场的蓬勃发展，喜航供应链在广州和深圳设立了分公司，进一步拓展服务渠道，为中国商家提供更多元化的物流解决方案。我们凭借中墨两地自营公司的无缝对接，确保跨境物流运作的高效与顺畅。",
    introduce12:
      "喜航供应链始终将客户体验放在首位，自主研发了先进的网络查询系统，简化操作流程，确保时效稳定。我们提供一对一的专属服务，让客户随时掌握货物状态，全程无忧。",
    introduce13:
      "十余年来，喜航供应链专注于清关服务，已成功服务上万跨境电商卖家，成为中国跨境电商物流领域的佼佼者。我们感谢每一位客户的支持与信任，并将继续努力，提供更优质的服务，与您共同成长。",
    introduce14:
      "选择喜航，选择专业、高效、安全、便捷的墨西哥物流服务。我们期待与您的合作，为您的业务发展提供强有力的支持。喜航供应链，您的跨境电商物流合作伙伴。",

    introduce1: "专业团队，铸就品质",
    introduce2:
      "喜航供应链拥有一支经验丰富、技术精湛的专业团队，他们深谙墨西哥市场的物流特点，能够为您提供量身定制的物流方案。无论是大宗货物的海运，还是急需物资的空运，我们都能确保货物安全、准时地送达目的地。",
    introduce3: "完善网络，覆盖全境",
    introduce4:
      "喜航供应链在墨西哥建立了完善的物流网络，覆盖全境各个角落。无论您的货物需要送达墨西哥城的繁华商圈，还是偏远的边境小镇，我们都能为您提供快捷、便利的物流服务。",
    introduce5: "科技助力，智能高效",
    introduce6:
      "我们采用先进的物流管理系统和智能跟踪技术，实现货物信息的实时更新和查询。您只需轻轻一点，就能随时掌握货物的最新动态，让您对物流过程了如指掌。",
    introduce7: "优质服务，客户至上",
    introduce8:
      "喜航供应链始终坚持“客户至上”的服务理念，为您提供贴心、周到的服务。我们的客服团队随时待命，为您解答疑问、处理问题，确保您的物流体验愉快而顺畅。",
    qrcode: "微信公众号"
  },
  advantage: {
    title: "我们的优势",
    content1: "专注发展墨西哥物流",
    content2: "全境无盲点派送",
    content3: "一站式物流服务",
    content4: "自有车队",
    content5: "快速理赔",
    content6: "收费简单透明",
    content7: "自主研发网络查询系统，简化操作流程",
    content8: "多样选择（辅助提货、换标、再送仓，整柜和拼箱清关派送）",
    content9: "深入了解客户痛点和需求，提供个性化、定制化的物流解决方案",
    content10:
      "积极拓展业务领域和市场范围，与更多电商平台和商家建立合作关系，提升市场份额"
  },
  service: {
    serviceDes:
      "喜航供应链，墨西哥物流领航者。我们深知物流之道，以专业铸就信任，以速度成就卓越。无论您的货物身处何方，喜航都能将其安全、准时送达墨西哥的每一个角落。选择喜航，选择安心与高效，让您的物流之路畅通无阻！",
    type1: "墨西哥海派/空派头程",
    type2: "墨西哥中转仓/墨西哥海外仓",
    typeTitle: "墨西哥海派",
    typeTitle3: "电商线",
    typeTitle4: "美墨线",
    typeTitle5: "墨西哥中转仓",
    typeTitle6: "墨西哥海外仓",
    typeTitle2: "墨西哥空派",
    typeDetails1: "开船后30-35到墨西哥仓库",
    typeDetails2: "开船后25-30天到墨西哥仓库",
    typeDetails3: "起飞后，7-10天到墨西哥仓库",
    typeDetails4:
      "提供贴标，中转送仓快速服务，仓库实行标准化管理 自有开发系统管理。",
    typeDetails5: "提供一件代发，退件，贴换产品标签等服务",
    adv1: "时效稳定",
    adv2: "快速清关",
    adv3: "安全有保障",
    adv4: "物流信息可视化管理",
    adv5: "预约系统",
    adv1Detail:
      "我们以卓越的装柜效率，与全球海运领域的佼佼者建立了稳固的战略合作,即使在物流行业的繁忙高峰，我们也能为您提供稳定且高效的舱位和运输服务",
    adv2Detail:
      "我们的清关专家团队具备非凡的实力，不仅拥有丰富的实战经验，7-10天快速清关，为您提供更为顺畅和高效的服务。",
    adv3Detail:
      "由经验丰富的华人精英团队掌控，确保沟通无阻。我们更提供全程安保押运，为货物在运输途中的安全保驾护航。",
    adv4Detail: "自主研发系统，匹配度高，规范整洁，安全高效，全程可视化",
    adv5Detail: "约仓更快捷、更高效",
    adv1Detail1: "确保本土发货的迅捷性",
    adv2Detail1:
      "海外仓通过大宗运输模式，有效降低了物流成本，相比国际快递，成本降低了百分之三十，这一成果进一步提升了的经济效益和竞争力。",
    adv3Detail1:
      "在处理货物时，海外仓展现了极高的专业性和适应性，对大件商品无明显的体积和重量限制，为卖家们提供了更广阔的市场拓展空间。",
    adv4Detail1:
      "针对退换货流程，我们采取严谨且高效的处理方式。对于客户退回的完好无损的商品，我们能够迅速进行二次处理并重新上架销售，有效减少成本。同时，凭借精准的市场定位和优质的服务，我们能够提高产品的定价水平，确保在本土市场上具有强大的竞争力。"
  },
  login: {
    loginType1: "OS客户端",
    loginType2: "轨迹查询",
    account: "账号",
    password: "密码",
    loginBtn: "登录",
    search: "查询",
    orderId: "请输入订单号"
  },
  timeLine: {
    timeline1: "2021年3月",
    timeValue1:
      "浙江喜航供应链有限公司，在义乌正式成立。开启中墨物流服务新征程。",
    timeDesc1:
      "公司成立之初，便凭借专业团队和优质服务，赢得客户认可，为后续发展奠定基础。",
    timeline2: "2022年6月",
    timeValue2: "深圳分公司成立",
    timeDesc2:
      "进一步拓展业务范围，提升服务能力。深圳作为中国电商之都，拥有丰富的电商资源，为喜航公司业务发展提供有力支持。",
    timeline3: "2023年5月",
    timeValue3: "广州分公司成立",
    timeDesc3:
      "完善公司战略布局，增强市场竞争力。广州是中国重要的物流枢纽之一，喜航广州分公司的成立，进一步提升公司在华南地区的服务能力。",
    timeline4: "2023年8月",
    timeValue4: "美墨线首航",
    timeDesc4:
      "标志着喜航公司在中墨物流领域迈出重要一步。美墨线的成功开通，为中美墨三 国电商贸易提供更加便捷的物流 通道，促进三国贸易往来。",
    timeline5: "2023年12月",
    timeValue5: "获美客多平台“年度优秀商务合作伙伴称号”",
    timeDesc5:
      "这是对喜航公司服务质量和专业能力的高度认可。该荣誉不仅提升了公司的品牌知名度，也为公司与美客多的长期合作奠定坚实基础。",
    timeline6: "2024年5月",
    timeValue6: "喜航成为华东地区首家美客多服务商（SPN）",
    timeDesc6:
      "进一步巩固公司在中墨物流市场的领先地位。作为美客多的重要合作伙伴，喜航公司为美客多商家提供全方位的物流服务，助力美客多业务发展。",
    timeline7: "2024年12月",
    timeValue7: "再获美客多平台“年度优秀商务合作伙伴称号”",
    timeDesc7:
      "这是对喜航公司持续努力和卓越表现的肯定。公司将继续加强与美客多的合作，不断提升服务质量和效率，为中墨电商贸易做出更大贡献。"
  },
  homePage: {
    title1: "喜航服务宗旨",
    content1:
      "跨越国界，连接世界，让全球物流畅通无阻，选择喜航，选择成功！让我们一起携手，共创美好未来！为客户创造无限可能。做物流行业的卓越伙伴",
    title2: "喜航愿景",
    content2: "喜航供应链以“喜以诚诺，航运墨达”为愿景",
    content4:
      "成为客户信赖的跨境物流引领者，以卓越服务重塑行业标准，驱动跨境贸易繁荣发展",
    title3: "喜航价值观",
    content3:
      "在当今快速发展的商业世界中，高效的物流是企业成功的关键。喜航作为行业的佼佼者，始终致力于为客户提供全方位、定制化的物流解决方案。秉持专业、高效、诚信、共赢的理念，凭借深厚专业素养，实现货物快速流转，坚守诚信底线，与客户、合作伙伴携手共进，共同开拓跨境物流新未来 "
  },
  navbar: {
    dashboard1: "首页",
    dashboard: "产品服务",
    nav1: "企业简介",
    nav2: "公司新闻",
    nav3: "查询界面",
    nav4: "服务内容",
    nav5: "联系我们"
  },
  aboutUs: {
    title1: "关于喜航",
    title2: "发展历程",
    title4: "竞争优势",
    value1: "客户至上",
    value2: "服务为本",
    value3: "争创行业先锋",
    leaveMessage: "留言给我们"
  },
  footer: {
    address: "浙江省义乌市宗泽北路505号218室",
    phone: "15325992926",
    email: "msk_cma@hotmail.com",
    copyRight: "版权所有",
    copyRight2: "浙ICP备2022005465号-1",
    product: "主营产品",
    product1: "义乌到墨西哥专线",
    product2: "广州到墨西哥专线",
    product3: "深圳到墨西哥专线"
  },
  contactUs: {
    userName: "姓名",
    userTel: "联系方式",
    companyName: "公司名称",
    userEmail: "邮箱",
    leaveContent: "您的需求",
    submit: "提交",
    submitSuccess: "提交成功",
    pleaseIpt: "请输入内容"
  }
};



// WEBPACK FOOTER //
// ./src/lang/es.js